import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Notification from "./Notification";
const Checkout = () => {
    const navigate = useNavigate();
    const [selectedPayment, setSelectedPayment] = useState("payment1");
    const [cartItems, setCartItems] = useState([]);
    const [cartTotal, setCartTotal] = useState(0);
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        business_name: "",
        country: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        postcode: "",
        phone: "",
        email: "",
        notes: ""
    });


    // Check login & fetch cart and user details
    useEffect(() => {
        const token = localStorage.getItem("token"); // user login token
        if (!token) {
            navigate("/account"); // redirect if not logged in
            return;
        }

        const cartToken = localStorage.getItem("cart_token");

        // Fetch WooCommerce cart data
        const fetchCartData = async () => {
            try {
                const res = await fetch(
                    "https://ecom.brightcodeapp.com/wp-json/wc/store/cart",
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            ...(cartToken && { "Cart-Token": cartToken })
                        }
                    }
                );

                const newCartToken = res.headers.get("Cart-Token");
                if (newCartToken) localStorage.setItem("cart_token", newCartToken);

                const data = await res.json();
                setCartItems(data.items || []);
                setCartTotal(data.totals.total_price / 100 || 0);
            } catch (err) {
                console.error("Cart Fetch Error:", err);
            }
        };

        // Fetch WooCommerce current user
        const fetchUserData = async () => {
            try {
                const res = await fetch(
                    // "https://ecom.brightcodeapp.com/wp-json/custom/v1/current_user",
                    `${process.env.REACT_APP_V1_WC_URL}/current_user`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (!res.ok) throw new Error("Failed to fetch user data");

                const user = await res.json();

                setFormData({
                    first_name: user.first_name || "",
                    last_name: user.last_name || "",
                    business_name: "", // not available in API
                    country: user.billing?.country || "",
                    address_1: user.billing?.address_1 || "",
                    address_2: user.billing?.address_2 || "",
                    city: user.billing?.city || "",
                    state: user.billing?.state || "",
                    postcode: user.billing?.postcode || "",
                    phone: user.billing?.phone || "",
                    email: user.email || "",
                    notes: ""
                });
            } catch (err) {
                console.error("User Fetch Error:", err);
            }
        };

        fetchCartData();
        fetchUserData();
    }, [navigate]);

    const handlePaymentChange = (event) => {
        setSelectedPayment(event.target.id);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleUpdateInformation = async () => {
        const token = localStorage.getItem("token");
        try {
            const res = await fetch(
                "https://ecom.brightcodeapp.com/wp-json/custom/v1/update_user",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        first_name: formData.first_name,
                        last_name: formData.last_name,
                        email: formData.email,
                        billing: {
                            address_1: formData.address_1,
                            address_2: formData.address_2,
                            city: formData.city,
                            state: formData.state,
                            postcode: formData.postcode,
                            country: formData.country,
                            phone: formData.phone
                        }
                    })
                }
            );

            if (!res.ok) {
                throw new Error("Failed to update user info");
            }

            const updated = await res.json();

            Notification.success(
                "Profile Updated",
                "Information updated successfully"
            );

           

        } catch (err) {

            console.error(err);

            Notification.error(
                "Update Failed",
                "Failed to update information"
            );
        }
    };



    const validateForm = () => {
        const {
            first_name,
            last_name,
            country,
            address_1,
            city,
            state,
            postcode,
            phone,
            email
        } = formData;

        if (
            !first_name ||
            !last_name ||
            !country ||
            !address_1 ||
            !city ||
            !state ||
            !postcode ||
            !phone ||
            !email
        ) {
            
            Notification.warning(
                "Validation Error",
                "Please fill in all required fields"
            );
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Notification.warning(
                "Validation Error",
                "Please enter a valid email address"
            );
            return false;
        }

        return true;
    };





    const handlePlaceOrder = async () => {
        if (!validateForm()) return;

        const cartToken = localStorage.getItem("cart_token");

        if (!cartToken) {
            Notification.warning(
                "Cart Empty",
                "Your cart is empty. Please add products before placing an order."
            );
            return;
        }

        const paymentMap = {
            payment1: "bacs",
            payment2: "cheque",
            payment3: "cod"
        };

        const paymentMethod = paymentMap[selectedPayment];

        try {

            //  Step 1: Fetch cart from WooCommerce
            const cartRes = await fetch(
                "https://ecom.brightcodeapp.com/wp-json/wc/store/cart",
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Cart-Token": cartToken
                    }
                }
            );

            const cartData = await cartRes.json();

            if (!cartData.items || cartData.items.length === 0) {
                Notification.warning(
                    "Cart Empty",
                    "Your cart is empty. Please add products before placing an order."
                );
                return;
            }

            

            //  Step 2: Convert Woo cart → Woo orders format
            const line_items = cartData.items.map(item => ({
                product_id: item.id,
                quantity: item.quantity
            }));

           
            const backend_url = process.env.REACT_APP_BACKEND_URL;
            //  Step 3: Create order
            const token = localStorage.getItem("token"); // or wherever you store it

            if (selectedPayment === "payment1") {

                const razorRes = await fetch(
                    `${backend_url}/api/create-razorpay-order/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            amount: cartTotal
                        })
                    }

                    
                );

                

                const razorData = await razorRes.json();

                const options = {
                    key: process.env.REACT_APP_RAZORPAY_KEY,
                    amount:razorData.amount,
                    currency: "INR",
                    name: "CoversVilla",
                    description: "Order Payment",
                    order_id: razorData.id,

                    prefill: {
                        name: `${formData.first_name} ${formData.last_name}`,
                        email: formData.email,
                        contact: formData.phone
                    },

                    handler: async function (response) {

                        // Create Woo Order only after payment success

                        const res = await fetch(
                            `${backend_url}/api/create-order/`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${token}`
                                },
                                body: JSON.stringify({
                                    payment_method: "bacs",
                                    payment_method_title: "RAZORPAY",
                                    set_paid: true,

                                    transaction_id:
                                        response.razorpay_payment_id,

                                    razorpay_order_id:
                                        response.razorpay_order_id,

                                    billing: {
                                        first_name: formData.first_name,
                                        last_name: formData.last_name,
                                        address_1: formData.address_1,
                                        address_2: formData.address_2,
                                        city: formData.city,
                                        state: formData.state,
                                        postcode: formData.postcode,
                                        country: formData.country,
                                        email: formData.email,
                                        phone: formData.phone
                                    },

                                    shipping: {
                                        first_name: formData.first_name,
                                        last_name: formData.last_name,
                                        address_1: formData.address_1,
                                        address_2: formData.address_2,
                                        city: formData.city,
                                        state: "JH",
                                        postcode: formData.postcode,
                                        country: "IN"
                                    },

                                    line_items,
                                    customer_note: formData.notes
                                })
                            }
                        );

                        if (res.ok) {

                            Notification.success(
                                "Payment Successful",
                                "Order placed successfully"
                            );

                            localStorage.removeItem("cart_token");

                            setTimeout(() => {
                                navigate("/my-orders");
                            }, 1000);
                        }
                    },

                    theme: {
                        color: "#3399cc"
                    }
                };

                const rzp = new window.Razorpay(options);

                rzp.on("payment.failed", function (response) {
                    Notification.error(
                        "Payment Failed",
                        response.error.description
                    );
                });

                rzp.open();

                return;
            }

            const res = await fetch(`${backend_url}/api/create-order/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`   //  IMPORTANT
                },
                body: JSON.stringify({
                    payment_method: paymentMethod,
                    payment_method_title: paymentMethod.toUpperCase(),
                    set_paid: false,

                    billing: {
                        first_name: formData.first_name,
                        last_name: formData.last_name,
                        address_1: formData.address_1,
                        address_2: formData.address_2,
                        city: formData.city,
                        state: formData.state,
                        postcode: formData.postcode,
                        country: formData.country,
                        email: formData.email,
                        phone: formData.phone
                    },

                    shipping: {
                        first_name: formData.first_name,
                        last_name: formData.last_name,
                        address_1: formData.address_1,
                        address_2: formData.address_2,
                        city: formData.city,
                        state: "JH",
                        postcode: formData.postcode,
                        country: "IN"
                    },

                    line_items: line_items,
                    customer_note: formData.notes
                })
            });

            const data = await res.json();

            if (!res.ok) {
                // throw new Error(data.message || "Order failed");
                Notification.error(
                    "Order Failed",
                    data.message || "Failed to place order"

                   
                    
                );
                setTimeout(() => {
                navigate("/account");
                }, 1000);
                return;
            }

            else {

                Notification.success(
                    "Order Placed",
                    "Your order has been placed successfully"
                );

                localStorage.removeItem("cart_token");
                setTimeout(() => {
                    navigate("/my-orders");
                    window.location.reload();
                }, 2000);
               
            }
            

        } catch (err) {

            console.error("Checkout Error:", err);

            Notification.error(
                "Checkout Failed",
                "An error occurred while placing your order"
            );

        }
    };


    return (
        <section className="checkout py-80">
            <div className="container container-lg">
                <div className="border border-gray-100 rounded-8 px-30 py-20 mb-40">
                    <span>
                        Have a coupon?{" "}
                        <Link
                            to="/cart"
                            className="fw-semibold text-gray-900 hover-text-decoration-underline hover-text-main-600"
                        >
                            Click here to enter your code
                        </Link>
                    </span>
                </div>

                <div className="row">
                    <div className="col-xl-9 col-lg-8">
                        <form action="#" className="pe-xl-5">
                            <div className="row gy-3">
                                {/* Billing Fields */}
                                <div className="col-sm-6 col-xs-6">
                                    <label htmlFor="first_name" className="form-label">First Name</label>
                                    <input
                                        type="text"
                                        id="first_name"
                                        name="first_name"
                                        className="common-input border-gray-100"
                                        placeholder="First Name"
                                        value={formData.first_name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-6">
                                    <label htmlFor="last_name" className="form-label">Last Name</label>
                                    <input
                                        type="text"
                                        id="last_name"
                                        name="last_name"
                                        className="common-input border-gray-100"
                                        placeholder="Last Name"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="country" className="form-label">Country</label>
                                    <input
                                        type="text"
                                        id="country"
                                        name="country"
                                        className="common-input border-gray-100"
                                        placeholder="United States (US)"
                                        value={formData.country}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="address_1" className="form-label">Address 1</label>
                                    <input
                                        type="text"
                                        id="address_1"
                                        name="address_1"
                                        className="common-input border-gray-100"
                                        placeholder="House number and street name"
                                        value={formData.address_1}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="address_2" className="form-label">Address 2</label>
                                    <input
                                        type="text"
                                        id="address_2"
                                        name="address_2"
                                        className="common-input border-gray-100"
                                        placeholder="Apartment, suite, unit, etc. (Optional)"
                                        value={formData.address_2}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="city" className="form-label">City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        className="common-input border-gray-100"
                                        placeholder="City"
                                        value={formData.city}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="state" className="form-label">State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        name="state"
                                        className="common-input border-gray-100"
                                        placeholder="State"
                                        value={formData.state}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="postcode" className="form-label">Post Code</label>
                                    <input
                                        type="text"
                                        id="postcode"
                                        name="postcode"
                                        className="common-input border-gray-100"
                                        placeholder="Post Code"
                                        value={formData.postcode}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="phone" className="form-label">Phone</label>
                                    <input
                                        type="number"
                                        id="phone"
                                        name="phone"
                                        className="common-input border-gray-100"
                                        placeholder="Phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="email" className="form-label">Email Address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="common-input border-gray-100"
                                        placeholder="Email Address"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>



                                {/* Update Button */}
                                <div className="col-12 mt-24">
                                    <button
                                        type="button"
                                        className="btn btn-main py-18 w-100 rounded-8"
                                        onClick={handleUpdateInformation}
                                    >
                                        Update Information
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>

                    {/* Sidebar (Cart & Payment) */}
                    <div className="col-xl-3 col-lg-4">
                        <div className="checkout-sidebar">
                            {/* <div className="bg-color-three rounded-8 p-2 text-center">
                                <span className="text-gray-900 text-xl fw-semibold">
                                    Your Orders
                                </span>

                                <button
                                type="button"
                                className="btn btn-main mt-40 py-18 w-100 rounded-8 mt-56"
                                onClick={handlePlaceOrder}
                            >
                                Place Orderdsd
                            </button>
                            </div> */}

                            <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                                <div className="mb-32 pb-32 border-bottom border-gray-100 flex-between gap-8">
                                    <span className="text-gray-900 fw-medium text-xl font-heading-two">
                                        Product
                                    </span>
                                    <span className="text-gray-900 fw-medium text-xl font-heading-two">
                                        Subtotal
                                    </span>
                                </div>

                                {cartItems.length > 0 ? (
                                    cartItems.map((item) => {
                                        const lineTotal = item.prices?.price
                                            ? (parseFloat(item.prices.price) * item.quantity) / 100
                                            : 0;
                                        return (
                                            <div
                                                className="flex-between gap-24 mb-32"
                                                key={item.key || item.id}
                                            >
                                                <div className="flex-align gap-12">
                                                    <span className="text-gray-900 fw-normal text-md font-heading-two w-144">
                                                        {item.name}
                                                    </span>
                                                    <span className="text-gray-900 fw-normal text-md font-heading-two">
                                                        <i className="ph-bold ph-x" />
                                                    </span>
                                                    <span className="text-gray-900 fw-semibold text-md font-heading-two">
                                                        {item.quantity}
                                                    </span>
                                                </div>
                                                <span className="text-gray-900 fw-bold text-md font-heading-two">
                                                    ₹{lineTotal.toFixed(2)}
                                                </span>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p className="text-gray-500">Your cart is empty.</p>
                                )}

                                {/* Total */}
                                <div className="border-top border-gray-100 pt-30 mt-30">
                                    <div className="mb-32 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                                            Total
                                        </span>
                                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                                            ₹{parseFloat(cartTotal || 0).toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Payment Options */}
                            <div className="mt-32">
                                {["payment1", "payment3"].map((payment) => (
                                    <div className="payment-item" key={payment}>
                                        <div className="form-check common-check common-radio py-16 mb-0">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="payment"
                                                id={payment}
                                                checked={selectedPayment === payment}
                                                onChange={handlePaymentChange}
                                            />
                                            <label
                                                className="form-check-label fw-semibold text-neutral-600"
                                                htmlFor={payment}
                                            >
                                                {payment === "payment1"
                                                    ? "Direct Bank transfer"
                                                    : "Cash on delivery"}
                                            </label>
                                        </div>
                                        {selectedPayment === payment && (
                                            <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                                                <p className="text-gray-800">
                                                    Make your payment directly into our bank account. Please use
                                                    your Order ID as the payment reference. Your order will not
                                                    be shipped until the funds have cleared in our account.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <div className="mt-32 pt-32 border-top border-gray-100">
                                <p className="text-gray-500">
                                    Your personal data will be used to process your order, support your
                                    experience throughout this website, and for other purposes described
                                    in our{" "}
                                    <Link to="#" className="text-main-600 text-decoration-underline">
                                        privacy policy
                                    </Link>
                                    .
                                </p>
                            </div>

                            <button
                                type="button"
                                className="btn btn-main mt-40 py-18 w-100 rounded-8 mt-56"
                                onClick={handlePlaceOrder}
                            >
                                Place Order
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Checkout;
